<template>
    <div><!--bg-gradient-warning-->
        <section class="section section section-shaped my-0 overflow-hidden">
            <div class="shape  shape-skew" style="background-image: linear-gradient(to bottom right, black, #002A46);">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container mt-5">
                <div class="row mt-5">
						<iframe class="col-6 mt-5" width="460" height="215" src="https://www.youtube.com/embed/yNQvAUNzL-0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
						<iframe class="col-6 mt-5" width="460" height="215" src="https://www.youtube.com/embed/fT_pem9kocM" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
                <div class="row mt-5">
						<iframe class="col-6 mt-5" width="460" height="215" src="https://www.youtube.com/embed/72d-lWB_zX0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
						<iframe class="col-6 mt-5" width="460" height="215" src="https://www.youtube.com/embed/TWpodbebNpc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
                <div class="row mt-5">
						<iframe class="col-6 mt-5" width="460" height="215" src="https://www.youtube.com/embed/ug5q5tukKiM" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
						<iframe class="col-6 mt-5" width="460" height="215" src="https://www.youtube.com/embed/cmtcrsXzyII" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
                <div class="row mt-5">
						<iframe class="col-6 mt-5" width="460" height="215" src="https://www.youtube.com/embed/AOsMX5pIW98" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
	            </div>
			</div>
        </section>
    </div>
</template>
<script>
export default {
  name: "Artist",
  components: {
	  	test () {
			console.log("hello")
		}
  },
	methods: {
		changeartistid (item) {
			this.$store.state.artistid = item
		}
	}
};

</script>
